import React from 'react'
import PropTypes from 'prop-types'

import Text from 'suitTheme/Text'

const textSize = {
  small: 'large',
  medium: 'xlarge',
  large: 'xxlarge',
  xlarge: 'xxxlarge',
}

const fontWeight = {
  light: 300,
  normal: 400,
  strong: 500,
}

const Heading = (props) => {
  const {
    children, size, textProps, weight,
  } = props

  return (
    <Text fontSize={textSize[size] || 'xxxlarge'} fontWeight={fontWeight[weight] || 300} {...textProps}>
      {children}
    </Text>
  )
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
  textProps: PropTypes.object,
  weight: PropTypes.oneOf(['light', 'normal', 'strong']),
}

export default Heading
